module.exports = __webpack_public_path__ + "img/fingerPrint.1b40d671.png";